import { inject } from '@angular/core';
import { Router, type UrlTree } from '@angular/router';
import { first, type Observable, of, switchMap } from 'rxjs';

import { Company } from '../models/company/company';
import { CompaniesService } from '../services/companies.service';
import { NotificationService } from '../services/notification.service';
import { UserService } from '../services/user.service';

/** Guard prevents user from accessing routes if company merchant status is not ready. */
export const merchantReadyGuard = (): Observable<boolean | UrlTree> => {
	const userService = inject(UserService);
	const companiesService = inject(CompaniesService);
	const router = inject(Router);
	const notificationService = inject(NotificationService);

	return userService.currentUser$.pipe(
		first(),
		switchMap(user => {
			if (user == null) {
				notificationService.notify('You need to be logged in to access this page');
				return of(false);
			}

			return companiesService.getCurrentCompany().pipe(
				switchMap(company => {
					if (Company.isVerified(company)) {
						return of(true);
					}

					// Redirect to home page to prevent infinite loops when accessing forbidden URLs directly
					return of(router.parseUrl('/'));
				}),
			);
		}),
	);
};
